import { EMPTY_OBJECT } from '../../../constants/common'
import { DRAG_DROP_SORT_STRATEGY } from '../DragDrop.constants'
import { getDragDropSortingStrategy } from '../DragDrop.utils'
import { SortableContextContainerProvider } from '../SortableContextContainerProvider'

function DragDropSortableList({
  children,
  id,
  items,
  sortableContextProps = EMPTY_OBJECT,
  strategy = DRAG_DROP_SORT_STRATEGY.vertical,
  ...restProps
}) {
  const listStrategy = getDragDropSortingStrategy(strategy)

  const sortableContainerProps = {
    ...sortableContextProps,
    id,
    items,
    strategy: listStrategy,
  }

  return (
    <div {...restProps}>
      <SortableContextContainerProvider {...sortableContainerProps}>
        {children}
      </SortableContextContainerProvider>
    </div>
  )
}

export default DragDropSortableList
